//import User from "../../models/User";
import axios from "axios";
// const { Device } = require("twilio-client");
import { API_BASE_URL, FETCH_LIMIT } from "../../globalVars";

export default {
  namespaced: true,

  actions: {
    async getToken(context) {
      const store = this;
      let response;
      response = await axios({
        method: "get",
        url: API_BASE_URL + `/telephony?for=signalwire&do=token`,
        data: {},
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`
        }
      }).catch(error => {
        if (error.response.data.message) {
          store.dispatch("entities/settings/update", {
            where: 1,
            data: {
              serverErrorMessage: error.response.data.message
            }
          });
        } else {
          store.dispatch("entities/settings/setIsOffline", true);
        }
      });

      // response = await axios({
      //   method: "get",
      //   url: API_BASE_URL + `/telephony`,
      //   data: {},
      //   headers: {
      //     Authorization: `Bearer ${localStorage.getItem("access_token")}`
      //   }
      // }).catch(error => {
      //   if (error.response.data.message) {
      //     store.dispatch("entities/settings/update", {
      //       where: 1,
      //       data: {
      //         serverErrorMessage: error.response.data.message
      //       }
      //     });
      //   } else {
      //     store.dispatch("entities/settings/setIsOffline", true);
      //   }
      // });

      if (response) {
        console.log("updating token in telephony");
        store.dispatch("entities/telephony/insertOrUpdate", {
          data: {
            id: 1,
            status: "ready",
            token:
              response.data && response.data.token ? response.data.token : null
          }
        });
        store.dispatch("entities/settings/setIsOffline", false);
        store.dispatch("entities/settings/update", {
          where: 1,
          data: {
            serverErrorMessage: null
          }
        });
        // Device.setup(response.data.token);
      }
    }

    // async getToken2(context, telephony) {
    //   if (user.isDirty === true) {
    //     const store = this;
    //     let response;

    //     const oldAccount = this.getters["entities/accounts/query"]().first();
    //     const accountId = oldAccount.id;
    //     response = await axios({
    //       method: "post",
    //       url: API_BASE_URL + `/telephony`,
    //       data: {
    //         accountId: accountId,
    //         authRoleId: user.authRoleId,
    //         firstName: user.firstName,
    //         lastName: user.lastName,
    //         email: user.email,
    //         mobilePhoneNumber: user.mobilePhoneNumber,
    //         roles: user.roles
    //       },
    //       headers: {
    //         Authorization: `Bearer ${localStorage.getItem("access_token")}`
    //       }
    //     }).catch(error => {
    //       if (error.response.data.message) {
    //         store.dispatch("entities/settings/update", {
    //           where: 1,
    //           data: {
    //             serverErrorMessage: error.response.data.message
    //           }
    //         });
    //       } else {
    //         store.dispatch("entities/settings/setIsOffline", true);
    //       }
    //     });
    //     if (response) {
    //       store.dispatch("entities/users/delete", {
    //         where: user.tempId
    //       });
    //       store.dispatch("entities/users/insert", {
    //         where: response.id,
    //         data: response.data
    //       });
    //       store.dispatch("entities/settings/setIsOffline", false);
    //       store.dispatch("entities/settings/update", {
    //         where: 1,
    //         data: {
    //           serverErrorMessage: null
    //         }
    //       });
    //     }
    //   }
    // }
  }
};
